import * as React from 'react';
import c from 'classnames';
import styles from './Payment.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DeluxeContext } from '../';
import { Title } from '../../title';
import { featuresList } from './FeaturesList';
import { ClickElement } from '../../form';

export const Payment = () => {
  return (
    <DeluxeContext.Consumer>
      {({ currentSelection, onClickHandlers }) => {
        const { payment: { period, frequency, prices } } = currentSelection;
        const { goToPage, selectionHandler } = onClickHandlers;

        const TermsLink = () => (
          <>&nbsp;Check de <ClickElement 
            ElementType="a"
            text='actievoorwaarden'
            testId="termsButton" 
            onClick={() => goToPage('terms', {
              action: `PaymentPage${period.charAt(0).toUpperCase() + period.slice(1)}ly`,
              label: 'TermsLink',
            })} />.</>
        );

        return (
          <div className={styles.payment}>
            <div className={styles.options}>
              <section>
                {period === 'year' && (
                  <>
                    <Title Tag='h1'>
                      DELUXE 1, 2 OF 3 JAAR
                    </Title>
                    <p>
                      Koop dit voor meer jaren en krijg meer kortings. 
                      Net als je relatie: Hoe langer je je vastlegt, hoe meer korting je krijgt.
                      <small>* Kies je kortingsperiode om verder te gaan</small>
                    </p>

                    <div className={styles.selector}>
                      <ClickElement
                        secondary={frequency === 1}
                        primary={frequency !== 1}
                        ElementType="button"
                        type="button"
                        testId='oneYearButton'
                        text={<>
                          <span>
                            {frequency === 1 && (<FontAwesomeIcon icon='check' className={styles.icon} />)}
                            1 Jaar
                          </span>
                          <small>( €2,99 p.m. )</small>
                        </>}
                        onClick={() => selectionHandler(1)}
                      />
                      <ClickElement
                        secondary={frequency === 2}
                        primary={frequency !== 2}
                        ElementType="button"
                        type="button"
                        testId='twoYearButton'
                        text={<>
                          <span>
                            {frequency === 2 && (<FontAwesomeIcon icon='check' className={styles.icon} />)}
                            2 Jaar
                          </span> 
                          <small>( €2,99 p.m. )</small>
                        </>}
                        onClick={() => selectionHandler(2)}                       
                      />
                      <ClickElement
                        secondary={frequency === 3}
                        primary={frequency !== 3}
                        ElementType="button"
                        type="button"
                        testId='threeYearButton'
                        text={<>
                          <span>
                            {frequency === 3 && (<FontAwesomeIcon icon='check' className={styles.icon} />)}
                          3 Jaar</span>
                          <small>( €1,99 p.m. )</small>
                        </>}
                        onClick={() => selectionHandler(3)}                        
                      />
                    </div>
                  </>
                )}
                {period === 'month' && (
                  <>
                    <Title Tag='h1'>
                      Deluxe Maandelijks
                    </Title>
                    <p>
                      Neem nu Dumpert Deluxe voor maar € 4,99 per maand en profiteer van alle kekke 
                      functionaliteiten en voordelen. 
                      Dumpert Deluxe is <strong>maandelijks opzegbaar</strong> dus je zit nergens aan vast.
                    </p>
                  </>
                )}
                {((frequency !== null && period === 'year') || period === 'month') && (
                  <>
                    <Title Tag='h2'>
                      JE BETAALT
                    </Title>
                    <div className={styles.price}>
                      {period === 'year' && (<div className={styles.retail}>€ {prices.retail}</div>)}
                      <div className={c(styles.action, {
                        [styles.month]: period === 'month',
                      })}><sup>€</sup>
                        {period === 'year' && (<>{prices.action}</>)}
                        {period === 'month' && (<span>4,99</span>)}
                      </div> 
                      <div className={styles.frequency}>per maand</div>
                    </div>
                    <hr />
                    <p>
                      <small>
                        {period === 'year' && (
                          <>* <strong>Let op</strong>: Je gaat een verplichting aan van 1, 2 of 3 jaar.</>
                        )}
                        <span className={styles.mobile}>{<TermsLink />}</span>
                      </small>
                    </p>
                    <ClickElement
                      primary
                      ElementType="button"
                      type="button"
                      testId="buyButton"
                      text={<span>Koop dan</span>}
                      onClick={() => goToPage('thanks', {
                        action: `PaymentPage${period.charAt(0).toUpperCase() + period.slice(1)}ly`,
                        label: 'BuyButton',
                      })
                      }
                    />
                  </>
                )}
              </section>
            </div>
            <div className={styles.list}>
              <section>
                {featuresList.map(item => (
                  <div className={styles['list-item']} key={item.title}>
                    <div>
                      <FontAwesomeIcon icon='check' className={styles.icon} />
                    </div>
                    <div>
                      <span>
                        {item.title}
                      </span>
                    </div> 
                  </div>
                ))}
                <p>En nog veel meer!{<TermsLink />}</p>
              </section>
            </div>
          </div>
        );
      }}
    </DeluxeContext.Consumer>
  );
};